import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * LaunchDarkly gate for visitor custom field admin UI (configuration tab, etc.).
 * Matches {@link FeatureFlag.VisitorManagementCustomFields} used by {@link CustomFieldsSection}.
 */
export function useVisitorCustomFieldsAdminUIEnabled(): boolean {
  return useFlag(FeatureFlag.VisitorManagementCustomFields, false) ?? false;
}
